import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-phone-number-pipe-page-ui',
    templateUrl: './bb-phone-number-page-ui.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PhoneNumberPageComponent {}
